"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formattingPeriod = void 0;
const num_word_1 = require("./num-word");
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["YEAR"] = "Y";
    TimeUnit["MONTH"] = "M";
    TimeUnit["DAY"] = "D";
})(TimeUnit || (TimeUnit = {}));
const ACCESS_TIME_UNIT = [TimeUnit.DAY, TimeUnit.MONTH, TimeUnit.YEAR];
const declination = {
    [TimeUnit.YEAR]: {
        one: 'год',
        few: 'года',
        many: 'лет',
    },
    [TimeUnit.MONTH]: {
        one: 'месяц',
        few: 'месяца',
        many: 'месяцев',
    },
    [TimeUnit.DAY]: {
        one: 'день',
        few: 'дня',
        many: 'дней',
    },
};
const formattingPeriod = (period) => {
    const timeUnit = period.slice(-1);
    if (!ACCESS_TIME_UNIT.includes(timeUnit)) {
        return '';
    }
    const duration = parseInt(period.slice(1, -1));
    const words = declination[timeUnit];
    return (0, num_word_1.declineWord)(duration, words);
};
exports.formattingPeriod = formattingPeriod;
